import { Component, Input, OnInit, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { from, of, Subject } from 'rxjs';
import { AppComponent } from '../app.component';
import { DataService } from "../services/data.service";
import { APIService } from './../api.service';
import { FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { filterPipe } from '../pipe/search/search.pipe';
import { VoucherEntryComponent } from '../voucher-entry/voucher-entry.component';
import { HeadsComponent } from '../heads/heads.component';
import { AccountsComponent } from '../accounts/accounts.component';
import * as xlsx from 'xlsx';
import { FinancialYearcountComponent } from '../financial-yearcount/financial-yearcount.component';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import * as importAll from "../heads/heads.component";
import { cloneDeep } from 'lodash';


@Component({
  selector: 'app-ledger-record',
  templateUrl: './ledger-record.component.html',
  styleUrls: ['./ledger-record.component.scss']
})

export class LedgerRecordComponent implements OnInit {

  @Input() changing: Subject<boolean> = new Subject();
  @Input() accountDates: Subject<{
    fdt: Date,
    tdt: Date,
    selectedFy: String
  }> = new Subject();
  @ViewChild('epltable', { static: false }) epltable!: ElementRef;


  chnageLedgerList: any = [];
  templedgerList: any = [];
  ledgername: any;
  ledgerid: any;
  Date: any;
  ledgerLists: any;
  isWeb: boolean = true;
  right: any;  
  jarvisData: any = [];

  constructor(private headService: DataService, private appService: DataService, 
    private apiService: APIService, private modalService: NgbModal, private router: Router, private SpinnerLoader: NgxSpinnerService) {

  }

  ngOnInit(): void {

    this.isWeb = this.apiService.apiCheckWeb();

    this.DateFilter.valueChanges
      .subscribe(
        DateFilter => {
          this.filterValues.date = DateFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.VoucherNumFilter.valueChanges
      .subscribe(
        VoucherNumFilter => {
          this.filterValues.VoucherNum = VoucherNumFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.MainLedgerFilter.valueChanges
      .subscribe(
        MainLedgerFilter => {
          this.filterValues.MainLedger = MainLedgerFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.CrAmtFilter.valueChanges
      .subscribe(
        CrAmtFilter => {
          this.filterValues.CrAmt = CrAmtFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.DbAmtFilter.valueChanges
      .subscribe(
        DbAmtFilter => {
          this.filterValues.DbAmt = DbAmtFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.CloBalFilter.valueChanges
      .subscribe(
        CloBalFiltert => {
          this.filterValues.CloBal = CloBalFiltert;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.NotesFilter.valueChanges
      .subscribe(
        NotesFilter => {
          this.filterValues.Notes = NotesFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    this.right = this.apiService.getCookie("J");
    if (this.right) {
      this.right = JSON.parse(this.right);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.right = $.grep(this.right, function (o: any) { return o.UserID == ownUserID })[0];      
    }
    else{
      window.location.href = "main.html#/home";
      return;
    }  

    this.financialYears = this.checkFinancialYear(new Date("2015"), new Date());
    this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    let currentDate = new Date();
    this.fn_Set_FinancialYear(currentDate);

    this.appService.tmpMyData.subscribe((value: any) => {
      this.ledger = value;
      this.getData();
    });

    this.changing.subscribe(v => {
      this.getData();
    });

    // let accountsDate: any = this.apiService.getCookie("AccountsDates");
    // if (accountsDate) {
    //   accountsDate = JSON.parse(accountsDate);
    //   if (accountsDate.length > 0) {
    //     this.fromDate = accountsDate[0].fdt;
    //     this.toDate = accountsDate[0].tdt;
    //   }
    // };
    if(this.accountDates) {
      this.accountDates.subscribe(dates => {
        this.fromDate = dates.fdt;
        this.toDate = dates.tdt;
      })
    }
  }

  agencyData: any = [];
  ledger: any = [];
  userList: any = [];
  data: any = [];
  voucher: any = [];
  displayedColumns: string[] = ['date', 'VoucherNum', 'MainLedger', 'DbAmt', 'CrAmt', 'CloBal', 'Notes'];
  data1: any = ['content', 'ledgerID', 'isHead']
  VoucherNumFilter = new FormControl('');
  MainLedgerFilter = new FormControl('');
  CrAmtFilter = new FormControl('');
  DbAmtFilter = new FormControl('');
  CloBalFilter = new FormControl('');
  NotesFilter = new FormControl('');
  DateFilter = new FormControl('');
  dataSource = new MatTableDataSource();
  modalReference: any;
  closeResult: string = '';
  isShowSearch: boolean = false;
  search: string = '';
  ledgers: any = [];
  today: any = new Date();
  selectedObj: any = {};
  fromDate: any;
  toDate: any;
  selectedDate: any;
  selectedFY: any;
  financialYears: any = [];
  ledgernData: any = [];

  filterValues = {
    date: '',
    VoucherNum: '',
    MainLedger: '',
    CrAmt: '',
    DbAmt: '',
    CloBal: '',
    Notes: ''
  };

  getData() {
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    let userList = this.apiService.getCookie("J");
    if (userList) {
      this.userList = JSON.parse(userList);

    }

    let tmpData = this.apiService.getCookie("Ledger");


    if (tmpData) {
      this.ledgers = cloneDeep(JSON.parse(tmpData));
    }

    // let accountsDate: any = this.apiService.getCookie("AccountsDates");
    // if (accountsDate) {
    //   accountsDate = JSON.parse(accountsDate);
    //   if (accountsDate.length > 0) {
    //     this.fromDate = accountsDate[0].fdt;
    //     this.toDate = accountsDate[0].tdt;
    //   }
    // };
    if(this.accountDates) {
      this.accountDates.subscribe(dates => {
        this.fromDate = dates.fdt;
        this.toDate = dates.tdt;
      })
    }
    
    if(this.ledger == null){
      return;
    }
    let data = [{
      LedgerId: this.ledger.id ? this.ledger.id : this.ledger.LedgerID,
      fromDT: new Date(this.fromDate).customFormat("#DD#-#MMM#-#YY#"),
      toDT: new Date(this.toDate).customFormat("#DD#-#MMM#-#YY#")
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'get',
      moduleID: 2,
      data: JSON.stringify(data)
    }];

    this.SpinnerLoader.show();
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
  }

  //failureResp - failure handler
  failureResp(res: any) {
    this.SpinnerLoader.hide();
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  //successResp - success  get handler
  successResp(res: any) {
    this.SpinnerLoader.hide();
    if (res.error) {
    }
    else {
      //this.appService.updateFinancialYearChange(1);     // 2023-09-11 - Commented by Ekta to avoid reloading full accounts data every time we try to bring one ledger's records.
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          this.data = reponseData;
          if (this.data.Table[0].ErrCode == '1') {
            alert(this.data.Table[0].ErrMsg);
            return;
          }
         this.voucher = this.data.Table1;
        //  this.voucher = this.data.Table2;

          this.voucher.forEach((e: any) => {
            e.date = new Date(e.EffectiveDate);
            let tmpUser = this.userList.filter((x: any) => x.UserID == e.CreatedUserID);
            if (tmpUser.length > 0) {
              e.user = tmpUser[0].Name;
            }
          });

          this.dataSource.data = this.voucher;
          this.dataSource.filterPredicate = this.createFilter();
          this.voucher.forEach((element: any) => {
            element.isShow = false;
            element.newCloBal = String(element.CloBal).indexOf(' Cr') > -1 ? '-' + element.CloBal : element.CloBal;
            element.newCloBal = String(element.newCloBal).replaceAll(',', "").replaceAll(' Cr', "").replaceAll(' Db', '');
          });

          if (this.voucher.length == 2) {
            var tempvouchlist = {
              CloBal: "0.00 Db",
              CrAmt: "0.00",
              CreatedUserID: 0,
              DbAmt: "0.00",
              DoneAmt: 0,
              EffectiveDate: "2021-04-01T00:00:00",
              MainLedger: "",
              MainLedgerID: 0,
              NewCrAmt: 0,
              NewDbAmt: 0,
              Notes: "",
              PaymentMode: "",
              PaymentRef: "",
              PndgAmt: "0.00 Db",
              Position: 1,
              ReconDate: "",
              VoucherFile: "",
              VoucherNum: "",
              VoucherType: "",
              date: "",
              isShow: false,
              newCloBal: "0.00"
            }
            this.voucher.splice(1, 0, tempvouchlist)

            // for (var i = 0; i < this.voucher.length; i++) {
            //   if (this.voucher[i].MainLedger == "Closing Balance") {
            //     this.voucher[this.voucher.length - 1] = this.voucher[i];
            //   }
            // }

          }
          //this.ledgername = localStorage.getItem("ledgername")
          this.ledgername = this.ledger.name ? this.ledger.name : this.ledger.LedgerName;
        }
      }
    }
  }

  //Change Ledger  

  // filterLedgerChange(id: any) {
  //   this.ledger.id = id;
  //   localStorage.removeItem("ledgerid");
  //   localStorage.setItem("ledgerid", this.ledger.id)

  //   var ledgerName = this.ledgerList.filter(function (element: any, index: any) {
  //     return (element.LedgerID == id);
  //   });

  // }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data: any, filter: any): boolean {
      let searchTerms = JSON.parse(filter);
      return data.VoucherNum.toString().toLowerCase().indexOf(searchTerms.VoucherNum) !== -1
        && data.MainLedger.toString().toLowerCase().indexOf(searchTerms.MainLedger) !== -1
        && data.CrAmt.toString().toLowerCase().indexOf(searchTerms.CrAmt) !== -1
        && data.DbAmt.toString().toLowerCase().indexOf(searchTerms.DbAmt) !== -1
        && data.CloBal.toString().toLowerCase().indexOf(searchTerms.CloBal) !== -1
        && data.Notes.toString().toLowerCase().indexOf(searchTerms.Notes) !== -1
        && data.date.toString().toLowerCase().indexOf(searchTerms.date) !== -1;
    }
    return filterFunction;
  }

  expandView() {
    let LedgerId = this.ledger.id ? this.ledger.id : this.ledger.LedgerID;
    let fromDT = new Date(this.fromDate).customFormat("#DD#-#MMM#-#YYYY#");
    let toDT = new Date(this.toDate).customFormat("#DD#-#MMM#-#YYYY#");
    // Using App
    let target: string = "_blank";
    if(this.isWeb == false){
      target = "_self";
    }
    if(this.apiService.fn_isLiveURL() == true){
      window.open('/ERP/LedgerRecord?lid=' + LedgerId + '&fromDT=' + encodeURIComponent(fromDT) + '&toDT=' + encodeURIComponent(toDT), target);
    }
    else{
      window.open('/LedgerRecord?lid=' + LedgerId + '&fromDT=' + encodeURIComponent(fromDT) + '&toDT=' + encodeURIComponent(toDT), target);
    }
    
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  showSearch() {
    this.isShowSearch = !this.isShowSearch;
  }

  //editData
  editVoucher(content: any, voucherID: any) {
    this.modalReference = this.modalService.open(VoucherEntryComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'my-class', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.voucherID = voucherID;
    this.modalReference.componentInstance.mdlRefHide = this.modalReference
    this.modalReference.result.then((result: any) => {
      if (result == true) {
        this.getData();
        this.appService.updateVoucherEntered(1);
      }
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

   openNewWindowVoucher(voucherID: any){
    let urlCheck: string = "";
    if (this.apiService.fn_isLiveURL() == true) {
      urlCheck = "/ERP";
    }
    urlCheck += "/voucher"; 
   
    // window.open(urlCheck, '_blank', 'height = 600, width = 1250');
     //var VID = voucherID;
     let target: string = "_blank";
     if(this.isWeb == false){
       target = "_self";
     }
 
    var win: any = window.open(urlCheck + '?voucherID=' + voucherID, target, 'height = 600, width = 1250');
    var timer = setInterval(() => {
      if(win != null){
        if (win.isSuccessVoucher) {
          clearInterval(timer);
          this.getData();
          this.appService.updateVoucherEntered(1);
          win.close();
        }
      }

      if (win.closed) {
          clearInterval(timer);
      }
    }, 100);
  }

  //closeEntryModal
  closeEntryModal() {
    this.modalReference.close();
  }

  //deleteVoucher
  deleteVoucher(voucherID: any) {
    if (confirm("Are you sure you wish to delete this voucher?")) {
      var tempData = [{
        'voucherID': voucherID
      }]

      let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'delete',
        moduleID: 0,
        data: JSON.stringify(tempData)
      }];

      this.apiService.sendChange(myParams, this.successVchrDelete.bind(this), this.failureResp.bind(this));
    }
  }

  //successVchrDelete 
  successVchrDelete(res: any) {
    if (res.error) {
    }
    else {
      alert(res.message);
      this.getData();
    }
  }

  ddlchangeYear() {
    let selectedYear;
    selectedYear = this.selectedFY.split("-")[0] + "";
    let toDate = (Number(selectedYear) + 1) + "/03/31";
    this.fn_Set_FinancialYear(toDate);
  }

  fn_Set_FinancialYear(ToDT: any) {
    var Date1 = new Date(ToDT);
    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      this.fromDate = new Date(Year + "/04/01");
      this.toDate = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      this.toDate = new Date(Year + "/03/31");
    }

    //this.getData(1);
    //this.getData();
  }


  //export to excel
  exportToExcel() {
    let element = document.getElementById('excel-table');

    const ws: xlsx.WorkSheet =
      xlsx.utils.table_to_sheet(element);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();

    xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
    xlsx.writeFile(wb, 'epltable.xlsx');
  }


  checkFinancialYear(date1: any, date2: any) {
    let financialYear = [];
    let fYear = new Date(date1).getFullYear();
    let lYear = new Date(date2).getFullYear();
    let toValueCheck = lYear;
    if (fYear == lYear) {
      let fMonth = new Date(date1).getMonth() + 1;
      if (fMonth < 4) {
        fYear = fYear - 1;
      }
      else {
        fYear = fYear;
      }
      let lMnth = new Date(date2).getMonth() + 1;
      if (lMnth > 3) {
        toValueCheck = lYear + 1;
      }

    }
    else {
      let fMonth = new Date(date1).getMonth() + 1;
      if (fMonth < 4) {
        fYear = fYear - 1;
      }
      else {
        fYear = fYear;
      }

      let lMnth = new Date(date2).getMonth() + 1;
      if (lMnth > 3) {
        toValueCheck = lYear + 1;
      }
    }


    for (var i = fYear; i < toValueCheck; i++) {
      financialYear.push({ 'FY': this.getCurrentFinancialYear('1-Apr-' + i) })
    }
    return financialYear;
  }

  getCurrentFinancialYear(fromDT: any) {
    var fiscalyear = "";
    var today = new Date(fromDT);
    if ((today.getMonth() + 1) < 4) {
      fiscalyear = (today.getFullYear() - 1) + "-" + today.getFullYear()
    } else {
      fiscalyear = today.getFullYear() + "-" + (today.getFullYear() + 1)
    }
    return fiscalyear
  }


  selectFinancialDate() {
    //this.modalReference = this.modalService.open(content);

    //If can change selectFinancialDate
    this.modalReference = this.modalService.open(FinancialYearcountComponent, { windowClass: "fycount", backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    let dateData: object = {
      fromDT: this.fromDate,
      toDT: this.toDate
    }
    this.modalReference.componentInstance.LedgerRecordData = dateData;

    this.modalReference.result.then((result: any) => {
      if (result) {
        this.fromDate = new Date(result.fromDT);
        this.toDate = new Date(result.toDT);
        this.getData();
      }
    });
  }

  printVoucher(id: number, name: string) {
    var VID = id;
    var name = name;
    let target: string = "_blank";
    if(this.isWeb == false){
      target = "_self";
    }
    //window.open('voucherPrint?VID=' + VID, '_blank', 'location=yes,height=1000,width=700,scrollbars=yes,status=yes');
    window.open('voucherPrint?VID=' + VID, target, 'Height= 900px, Width= 900px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
    //this.router.navigateByUrl('voucherPrint?VID=' + VID);
  }

  deleteLedger(LedgerID: any) {

    if (confirm("Do you wish to delete this ledger?")) {

      var tempData = [{
        'ledgerID': LedgerID
      }]

      let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'delete',
        moduleID: 2,
        data: JSON.stringify(tempData)
      }];
      this.apiService.sendChange(myParams, this.successDelete.bind(this), this.failureDelete.bind(this));

    }
  }


  failureDelete(res: any) {
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  //successResp - success  get handler

  successDelete(res: any) {
    if (res.error) {
      alert(res.message);
    }
    else {
      alert(res.message);
      window.location.reload();
    }
  }

  //let data: any = [content: any, isHead: boolean, ledgerID: number];

  Editledger(content: any, isHead: boolean, ledgerID: number) {
    
    // console.log(importAll.opeEditDeleetPopup(this.data1))
    //this.headService.headDatas(ledgerID);

  }

  // Ledger recorde list

  filterLedgerChange(name: string) {
    //this.ledger.name = name;
    let ledger = this.ledgers.find((l: any) => l.LedgerName == name);
    this.appService.updateData(ledger);
    
    this.apiService.setCookie("slectedHeadID", 0);
    this.apiService.setCookie("slectedLeaderID", 0);

    if(ledger == null){
      return;
    }

    let data = [{
      LedgerId: ledger.LedgerID,
      fromDT: new Date(this.fromDate).customFormat("#DD#-#MMM#-#YY#"),
      toDT: new Date(this.toDate).customFormat("#DD#-#MMM#-#YY#")
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'get',
      moduleID: 2,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));

  }

  openAttFile(filepath: any){
    let url: string = "";
    if(this.apiService.fn_isLiveURL() == true){
        url = "https://biziverse.com/ERPAPI/" + filepath;
    }
    else{
      url = "http://localhost:60673/" + filepath;
    }    
    window.open(url, '_blank', 'height = 500px, width= 1000px,top = 100px,left=100px');
  }

  printLedgerRecord() {
    this.appService.ledgerRecordPrintData(this.voucher);

    let ledgerID: number = this.ledger.id ? this.ledger.id : this.ledger.LedgerID;
    let target = "_blank";
    // if(this.isWeb == false){
    //   target = "_self";
    // }
    window.open(
      'LedgerRecordPrint?LID=' + ledgerID +
      '&fdt=' + new Date(this.fromDate).customFormat('#DD#-#MMM#-#YY#') +
      '&tdt=' + new Date(this.toDate).customFormat('#DD#-#MMM#-#YY#') +
      '&lname=' + encodeURIComponent(this.ledgername), target,
      'Height= 900px, Width= 1100px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No'
    );
  }
}

declare global {
  interface Date {
    customFormat(formatString: any): string;
  }
}

// String Prototye
Date.prototype.customFormat = function (formatString: any) {
  var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhhh, hhh, hh, h, mm, m, ss, s, ampm, AMPM, dMod, th;
  YY = ((YYYY = this.getFullYear()) + "").slice(-2);
  MM = (M = this.getMonth() + 1) < 10 ? ('0' + M) : M;
  MMM = (MMMM = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][M - 1]).substring(0, 3);
  DD = (D = this.getDate()) < 10 ? ('0' + D) : D;
  DDD = (DDDD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][this.getDay()]).substring(0, 3);
  th = (D >= 10 && D <= 20) ? 'th' : ((dMod = D % 10) == 1) ? 'st' : (dMod == 2) ? 'nd' : (dMod == 3) ? 'rd' : 'th';
  formatString = formatString.replace("#YYYY#", YYYY).replace("#YY#", YY).replace("#MMMM#", MMMM).replace("#MMM#", MMM).replace("#MM#", MM).replace("#M#", M).replace("#DDDD#", DDDD).replace("#DDD#", DDD).replace("#DD#", DD).replace("#D#", D).replace("#th#", th);
  h = (hhh = this.getHours());
  if (h == 0) h = 24;
  if (h > 12) h -= 12;
  hh = h < 10 ? ('0' + h) : h;
  hhhh = h < 10 ? ('0' + hhh) : hhh;
  AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
  mm = (m = this.getMinutes()) < 10 ? ('0' + m) : m;
  ss = (s = this.getSeconds()) < 10 ? ('0' + s) : s;
  return formatString.replace("#hhhh#", hhhh).replace("#hhh#", hhh).replace("#hh#", hh).replace("#h#", h).replace("#mm#", mm).replace("#m#", m).replace("#ss#", ss).replace("#s#", s).replace("#ampm#", ampm).replace("#AMPM#", AMPM);
}

